import AccountingDocument from "../shared/documentInfrastructure/AccountingDocument2/AccountingDocument.js";
import ForecastTemplateArchiveDocumentContent from "./ForecastTemplateArchiveDocumentContent/ForecastTemplateArchiveDocumentContent.js";
import ForecastTemplateArchiveDocumentCoordinator from "./ForecastTemplateArchiveDocumentCoordinator.js";
import ForecastTemplateArchiveDocumentService from "./ForecastTemplateArchiveDocumentService.js";
import ForecastTemplateArchiveDocumentState from "./ForecastTemplateArchiveDocumentState.js";
import ForecastTemplateArchiveTitleWidget from "./widgets/ForecastTemplateArchiveTitleWidget/ForecastTemplateArchiveTitleWidget.js";
import session from "../../core/session.js";

/**
 * Create and return a new forecast editor document and everything
 * that this document requires.
 */
export default function makeForecastTemplateArchiveDocument() {
	const coordinator = new ForecastTemplateArchiveDocumentCoordinator({
		documentState: new ForecastTemplateArchiveDocumentState({
			service: new ForecastTemplateArchiveDocumentService({ session }),
		}),
		renderables: {
			content: new ForecastTemplateArchiveDocumentContent(),
			title: new ForecastTemplateArchiveTitleWidget(),
			periodPicker: false,
		},
	});

	return new AccountingDocument({ coordinator });
}
